"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const react_1 = require("react");
const react_datepicker_1 = __importDefault(require("react-datepicker"));
const Input_1 = require("./Input");
const date_1 = require("../../constants/date");
const hooks_1 = require("../../hooks");
const translate_1 = require("../../translate");
const utils_1 = require("../../utils");
const DATE_PICKER_ICON = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjBweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjBweCIgZmlsbD0iIzAwMDAwMCI+CiAgICA8cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogICAgPHBhdGggZD0iTTE5IDNoLTFWMWgtMnYySDhWMUg2djJINWMtMS4xMSAwLTEuOTkuOS0xLjk5IDJMMyAxOWMwIDEuMS44OSAyIDIgMmgxNGMxLjEgMCAyLS45IDItMlY1YzAtMS4xLS45LTItMi0yem0wIDE2SDVWOGgxNHYxMXpNNyAxMGg1djVIN3oiIC8+Cjwvc3ZnPg==';
const DATE_RANGE_PICKER_ICON = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjBweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjBweCIgZmlsbD0iIzAwMDAwMCI+PHBhdGggZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIvPjxwYXRoIGQ9Ik05IDExSDd2Mmgydi0yem00IDBoLTJ2Mmgydi0yem00IDBoLTJ2Mmgydi0yem0yLTdoLTFWMmgtMnYySDhWMkg2djJINWMtMS4xMSAwLTEuOTkuOS0xLjk5IDJMMyAyMGMwIDEuMS44OSAyIDIgMmgxNGMxLjEgMCAyLS45IDItMlY2YzAtMS4xLS45LTItMi0yem0wIDE2SDVWOWgxNHYxMXoiLz48L3N2Zz4K';
const DatePickerElement = styled_1.default.div((props) => ({
    display: 'flex',
    flexDirection: 'column',
    ...(0, utils_1.createStyles)(props.styles),
}));
const toDate = (date) => {
    return typeof date === 'number' ? new Date(date) : date;
};
const DatePickerInput = (0, react_1.forwardRef)(({ onDateChange, ...props }, ref) => {
    return ((0, jsx_runtime_1.jsx)(Input_1.Input, { ...props, icon: props.range ? DATE_RANGE_PICKER_ICON : DATE_PICKER_ICON, innerRef: ref, nativeOnChange: (event) => {
            const date = new Date(event.target.value);
            // Update the date only if it's a valid date:
            if (!Number.isNaN(date.getTime())) {
                onDateChange(date, date);
            }
            props.onChange?.(event);
        }, onChange: undefined }));
});
DatePickerInput.displayName = 'DatePickerInput';
const DatePicker = (props) => {
    const locale = (0, translate_1.useLocale)();
    const t = (0, translate_1.useTranslations)();
    const localeOptions = date_1.DATE_FNS_LOCALE_OPTIONS[locale];
    const handleChange = (date) => {
        const [startDate, endDate] = Array.isArray(date) ? date : [date, date];
        props.onChange(startDate, endDate);
    };
    const validateError = (0, hooks_1.useValidate)(props.schema, props.required, props.range
        ? props.startDate && props.endDate
            ? [props.startDate, props.endDate]
            : null
        : props.value);
    const customInput = ((0, jsx_runtime_1.jsx)(DatePickerInput, { range: !!props.range, description: props.description, label: props.label, labelIcon: props.labelIcon, onDateChange: props.onChange, required: props.required, errorMessage: props.errorMessage ?? validateError, reserveErrorSpace: props.reserveErrorSpace, forceShowError: props.forceShowError, styles: props.inputStyles }));
    const dateFormat = props.dateFormat ??
        (props.showYearPicker
            ? 'yyyy'
            : props.range
                ? localeOptions.dateFormat.short
                : localeOptions.dateFormat.long);
    return ((0, jsx_runtime_1.jsx)(DatePickerElement, { className: props.className, styles: props.styles, children: (0, jsx_runtime_1.jsx)(react_datepicker_1.default, { id: props.id, inline: props.inline, customInput: props.input ?? (props.inline ? undefined : customInput), dateFormat: dateFormat, disabled: props.disabled, endDate: toDate(props.endDate), locale: localeOptions.locale, maxDate: toDate(props.maxDate), minDate: toDate(props.minDate), monthsShown: props.range ? 2 : 1, onChange: handleChange, placeholderText: props.placeholder ?? `${t.form.select_a_date()}...`, required: props.required, selected: toDate(props.value), selectsRange: props.range, showWeekNumbers: true, showYearPicker: props.showYearPicker, startDate: toDate(props.startDate) }) }));
};
exports.DatePicker = DatePicker;
